export const OrderStatusEnum = {
    PENDING: 'pending',
    CANCELED_BY_ADMIN: 'canceled_by_admin',
    CANCELED_BY_USER: 'canceled_by_user',
    PAID: 'paid',
    NOT_PAID: 'not_paid',
    COMPLETED: 'completed',
    STOPPED: 'stopped',
};
